import { twMerge } from "tailwind-merge";

export function Heading2({
  children,
  className,
  id,
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) {
  return (
    <h2
      id={id}
      className={twMerge(
        "text-3xl font-semibold tracking-tight text-gray-900",
        className
      )}
    >
      {children}
    </h2>
  );
}
